
  // Pēc nosūtīšanas Shopify atgriež ?contact_posted=true
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    document.getElementById('form-flash').style.display = 'block';
    document.getElementById('pieteikums').scrollIntoView();
  }

  // Tēmas dublēto H1 un breadcrumb izņemam no DOM (SEO: lapā tikai viens H1)
  document.querySelectorAll('.main-page-title, nav.breadcrumb').forEach(function(el){ el.remove(); });

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sekciju atklāšanās ritinot + laika skalas palaišana
  var items = document.querySelectorAll('.reveal');
  var timeline = document.querySelector('.timeline');
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function(el){ el.classList.add('in'); });
    if (timeline) timeline.classList.add('play');
    var v = document.querySelector('video');
    if (reduce && v) { v.removeAttribute('autoplay'); v.pause(); }
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    items.forEach(function(el){ io.observe(el); });
    var tio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { timeline.classList.add('play'); tio.disconnect(); }
      });
    }, { threshold: 0.35 });
    if (timeline) tio.observe(timeline);
  }

  // Lipīgās navigācijas scrollspy
  var links = Array.prototype.slice.call(document.querySelectorAll('.snl'));
  var byId = {};
  links.forEach(function(a){ byId[a.getAttribute('href').slice(1)] = a; });
  if ('IntersectionObserver' in window) {
    var spy = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting && byId[en.target.id]) {
          links.forEach(function(a){ a.classList.remove('active'); });
          byId[en.target.id].classList.add('active');
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(byId).forEach(function(id){
      var s = document.getElementById(id);
      if (s) spy.observe(s);
    });
  }

  // Projektu karuselis: bultas, progresa līnija, vilkšana ar peli
  var track = document.getElementById('car-track');
  if (track) {
    var slides = track.querySelectorAll('.car-slide');
    var fill = document.getElementById('car-fill');
    function slideW(){ return slides[0].getBoundingClientRect().width + 16; }
    function current(){ return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / slideW()))); }
    function go(d){
      var target = Math.max(0, Math.min(slides.length - 1, current() + d));
      var left = Math.round(target * slideW());
      track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function(){
        if (Math.abs(track.scrollLeft - left) > 8) track.scrollTo({ left: left, behavior: 'auto' });
      }, 380);
    }
    document.getElementById('car-prev').addEventListener('click', function(){ go(-1); });
    document.getElementById('car-next').addEventListener('click', function(){ go(1); });
    function paint(){
      var seen = Math.min(track.scrollWidth, track.scrollLeft + track.clientWidth);
      fill.style.width = (seen / track.scrollWidth * 100).toFixed(1) + '%';
    }
    paint();
    var raf;
    track.addEventListener('scroll', function(){
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(paint);
    });
    window.addEventListener('resize', paint);
    var dragging = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse') return;
      dragging = true; sx = e.clientX; sl = track.scrollLeft;
      track.classList.add('dragging');
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function(e){
      if (dragging) track.scrollLeft = sl - (e.clientX - sx);
    });
    function endDrag(){
      if (!dragging) return;
      dragging = false;
      track.classList.remove('dragging');
      track.scrollTo({ left: Math.round(current() * slideW()), behavior: reduce ? 'auto' : 'smooth' });
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  }

  // FAQ atvēršanās animācija (bez tās - parastais details)
  if (!reduce) {
    document.querySelectorAll('.faq details').forEach(function(d){
      var sum = d.querySelector('summary');
      var ans = d.querySelector('.answer');
      sum.addEventListener('click', function(e){
        e.preventDefault();
        if (d.hasAttribute('data-anim')) return;
        d.setAttribute('data-anim', '');
        if (d.open) {
          ans.style.height = ans.scrollHeight + 'px';
          requestAnimationFrame(function(){
            ans.style.height = '0px';
            ans.style.paddingBottom = '0px';
          });
          ans.addEventListener('transitionend', function(){
            d.open = false;
            ans.style.height = ''; ans.style.paddingBottom = '';
            d.removeAttribute('data-anim');
          }, { once: true });
        } else {
          d.open = true;
          var h = ans.scrollHeight;
          ans.style.height = '0px';
          ans.style.paddingBottom = '0px';
          requestAnimationFrame(function(){
            ans.style.height = h + 'px';
            ans.style.paddingBottom = '';
          });
          ans.addEventListener('transitionend', function(){
            ans.style.height = '';
            d.removeAttribute('data-anim');
          }, { once: true });
        }
      });
    });
  }
  setTimeout(function(){
    document.querySelectorAll('.esb2b .reveal').forEach(function(el){ el.classList.add('in'); });
    var tl2 = document.querySelector('.timeline'); if (tl2) tl2.classList.add('play');
  }, 2500);
